import { getHelpTextId } from '../../help-text/utils/get-help-text-id';
/**
 * Returns input props based on validation state.
 *
 * @param props The input field props.
 * @param fieldValidatorState The validating state and events.
 * @param errorMessage The error message, if applicable.
 *
 * @returns The props supplied and the calculated input props.
 */
export const getInputProps = (props, fieldValidatorState, errorMessage) => {
    const { id, value, displayText, validationConfig, onChangeValue } = props;
    const { isValidating, onValueChangedValidation, onBlurValidation } = fieldValidatorState;
    return Object.assign(Object.assign({}, props), { placeholder: 'placeholder' in displayText ? displayText.placeholder : undefined, className: undefined, helpTextId: errorMessage ? getHelpTextId(id) : undefined, onBlur: () => onBlurValidation(value), onChangeValue: newValue => {
            onChangeValue === null || onChangeValue === void 0 ? void 0 : onChangeValue(newValue);
            onValueChangedValidation(newValue, !!errorMessage);
        }, isValidating, maxLength: validationConfig === null || validationConfig === void 0 ? void 0 : validationConfig.maxLength });
};
